package de.ohhhmhhh.frontend.admin.ui.components.inputs

import kotlin.js.Promise

class EditorController {
    var factory: (() -> Promise<String>)? = null

    fun save(): Promise<String> = factory!!.invoke()
}